import React from "react";
import sessionexpiredimg from "../../Assets/sessionExpired.svg";
import "./SessionExpiredModal.scss";
import getTranslationData from "../../TranslationUtility/TranslationUtility";

const SessionExpiredModal = ({ isOpen, onClose }) => {

  const translation = getTranslationData(); // ✅ yaha call karo

  return (
    <div
      className={`modal-dropbox ${isOpen ? "" : "d-none"}`}
      onClick={() => onClose()}
    >
      <div className="modal-content-elements" onClick={(e) => e.stopPropagation()}>
        <i className="fa fa-times modal-close-icon" onClick={() => onClose()}></i>

        <img
          width={60.57}
          height={66.67}
          src={sessionexpiredimg}
          alt="Session Expired"
        />

        <div className="modal-bottom-text">
          <h3 className="session-expired-heading">
            {translation?.session_expire_heading || "Session Expired"}
          </h3>

          <p className="session-expired-text">
            {translation?.session_expire_msg || "Session expired due to inactivity"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
